<template>
<div class="chapter">
<div class="inner_page">
<p class="chap"> </p>
<p class="center"><i>The last chord has died away. In the brief silence which follows I feel strongly that there it is, that something has happened.</i></p>
<p class="center">—Jean-Paul Sartre</p>
<p class="center"> </p>
<p class="center"><i>Don’t you ever listen to the radio when the big bad beat comes on?</i></p>
<p class="center">—Bob Seger</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi.vue?07208bcf